import { render } from "./index.vue?vue&type=template&id=31eaa1d6&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=31eaa1d6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31eaa1d6"]])

export default __exports__